
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { post } from '../../../helpers/api_helper';
import { GET_UPDATE_CHEQUE_FORMATE, POST_CHEQUE_ISSUED_DETAIL } from '../../../helpers/url_helper';
import { toast } from 'react-toastify';
import useMounted from '../../../hooks/useMounted';
import Loader from '../../../components/Loader';
import { useTranslation } from 'react-i18next';


const ChequeSettingForm = (props) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const [isLoader, setLoader] = useState(0);
    const [ButtonDisabled, SetButtonDisabled] = useState(false);
    const [form_inputs, setInputs] = useState({ bankId: '', formatId: '' });
    const [BankList, SetBankList] = useState([]);
    const [BankChequeFormatList, SetChequeFormatList] = useState([]);


    useMounted(() => {
        async function get_detaile() {
            await get_deatile();
            setLoader(1);
        }
        get_detaile();
    }, [])

    const get_deatile = async () => {
        var res_data = await post(POST_CHEQUE_ISSUED_DETAIL, { chequeId: 0 });
        if (res_data.status) {
            SetBankList(res_data.data.bankList);
            if (res_data.data.cheque_format && form_inputs.formatId <= 0) {
                var formatObject = findObjectById(res_data.data.bankList, res_data.data.cheque_format.bankId, 'bankId');
                SetChequeFormatList(formatObject.formatList)
                setInputs({ ...res_data.data.cheque_format });
            } else {
                if(form_inputs.bankId){
                    var formatObject1 = findObjectById(res_data.data.bankList, form_inputs.bankId, 'bankId');
                    SetChequeFormatList(formatObject1.formatList);
                    if(formatObject1.formatList && formatObject1.formatList.length > 0){
                        var data = findObjectById(formatObject1.formatList, formatObject1.formatList[0].formatId, 'formatId');
                        if (data) {
                            setInputs({ ...data });
                        }
                    }
                }
            }
        } else {
            toast.error(res_data.message);
            navigate("/");
        }
    }

    // form submit event
    const handleSubmit = async (event) => {
        event.preventDefault();
        SetButtonDisabled(true);
        var res_data = await post(GET_UPDATE_CHEQUE_FORMATE, form_inputs);
        if (res_data.status) {
            toast(res_data.message);
            await get_deatile();
        } else {
            toast.error(res_data.message);
        }
        SetButtonDisabled(false);
    }

    // input text change handler
    const handleInputChange = async (event) => {
        if (event.target.name === 'bankId') {
            var formatObject = findObjectById(BankList, event.target.value, 'bankId');
            if (formatObject) {
                SetChequeFormatList(formatObject.formatList)
            } else {
                SetChequeFormatList([])
            }
            form_inputs.bankId = event.target.value;
            form_inputs.formatId = '';
            setInputs({ ...form_inputs });
        } else if (event.target.name === 'formatId') {
            var data = findObjectById(BankChequeFormatList, event.target.value, 'formatId');
            if (data) {
                setInputs({ ...data });
            } else {
                setInputs({ bankId: form_inputs.bankId, formatId: event.target.value });
            }
        } else {
            setInputs(inputs => ({ ...form_inputs, [event.target.name]: event.target.value }));
        }
    }

    function findObjectById(arr, id, key = "id") {
        if (!Array.isArray(arr)) {
            throw new Error("First argument must be an array.");
        }
        return arr.find(item => parseInt(item[key]) === parseInt(id)) || null;
    }

    const setDefaultSetting = async () => {
        SetButtonDisabled(true);
        form_inputs.setDefault = true;
        var res_data = await post(GET_UPDATE_CHEQUE_FORMATE, form_inputs);
        if (res_data.status) {
            await get_deatile();
            toast(res_data.message);
        } else {
            toast.error(res_data.message);
        }
        SetButtonDisabled(false);
    }


    return (
        <>
            {!isLoader && <Loader />}
            <div className='row'>
                <div className="col-md-12">
                    <div className="card mb-4">
                        <h5 className="card-header">{t('sideMenu.settings')}</h5>
                        <div className="card-body">
                            <form className="av-invalid" onSubmit={handleSubmit}>
                                <div className='row mb-4'>
                                    <div className='mb-3 col-sm-6 col-md-4'>
                                        <label className="form-label text-capitalize">{t('chequeIssued.form.selectBank')} *</label>
                                        <select name="bankId" value={form_inputs.bankId} onChange={handleInputChange} className="form-control">
                                            <option value="">{t('chequeIssued.form.selectBank')}</option>
                                            {BankList && BankList.map((value) => {
                                                return (
                                                    <option value={value.bankId} key={value.bankId}>{value.bankName}</option>
                                                )
                                            })}
                                        </select>
                                    </div>
                                    <div className='mb-3 col-sm-6 col-md-4'>
                                        <label className="form-label text-capitalize">{t('chequeIssued.form.selectFormat')} *</label>
                                        <select name="formatId" value={form_inputs.formatId} onChange={handleInputChange} className="form-control">
                                            <option value="">{t('chequeIssued.form.selectFormat')}</option>
                                            {BankChequeFormatList && BankChequeFormatList.map((value) => {
                                                return (
                                                    <option value={value.formatId} key={value.formatId}>{value.formatName}</option>
                                                )
                                            })}
                                        </select>
                                    </div>
                                </div>
                                {form_inputs.formatId && <>
                                    <div className='row mb-3'>
                                        <div className='col-sm-12 text-center'>
                                            <p className='mb-0'><b>{t('setting.chequePrintingConfiguration')}</b></p>
                                            <p><small>{t('setting.allDimensionsInMmOnly')}</small></p>
                                        </div>
                                        <div className='col-sm-6'>
                                            <p><b><u>{t('setting.chequeDimension')}</u></b></p>
                                            <div className='row mb-3'>
                                                <div className='col-9'>
                                                    <p className='mb-0'>{t('setting.widthOfCheque')}</p>
                                                </div>
                                                <div className='col-3'>
                                                    <input type='text' name="chequeWidth" value={form_inputs.chequeWidth} onChange={handleInputChange} className='form-control' placeholder='mm' />
                                                </div>
                                            </div>
                                            <div className='row mb-3'>
                                                <div className='col-9'>
                                                    <p className='mb-0'>{t('setting.heightOfCheque')}</p>
                                                </div>
                                                <div className='col-3'>
                                                    <input type='text' name="chequeHeight" value={form_inputs.chequeHeight} onChange={handleInputChange} className='form-control' placeholder='mm' />
                                                </div>
                                            </div>

                                            <p><b><u>{t('setting.chequeDate')}</u></b></p>
                                            <div className='row mb-3'>
                                                <div className='col-9'>
                                                    <p className='mb-0'>{t('setting.startingLocationFromTopEdge')}</p>
                                                </div>
                                                <div className='col-3'>
                                                    <input type='text' name="chequeDateStartingLocationFromTop" value={form_inputs.chequeDateStartingLocationFromTop} onChange={handleInputChange} className='form-control' placeholder='mm' />
                                                </div>
                                            </div>
                                            <div className='row mb-3'>
                                                <div className='col-9'>
                                                    <p className='mb-0'>{t('setting.startingLocationFromLeftEdge')}</p>
                                                </div>
                                                <div className='col-3'>
                                                    <input type='text' name="chequeDateStartingLocationFromLeft" value={form_inputs.chequeDateStartingLocationFromLeft} onChange={handleInputChange} className='form-control' placeholder='mm' />
                                                </div>
                                            </div>
                                            <div className='row mb-3'>
                                                <div className='col-9'>
                                                    <p className='mb-0'>{t('setting.styleOfDate')}</p>
                                                </div>
                                                <div className='col-3'>
                                                    <select type='text' name='chequeDateStyleOfDate' value={form_inputs.chequeDateStyleOfDate} onChange={handleInputChange} className='form-control' >
                                                        <option value="">{t('setting.selectDate')}</option>
                                                        <option value="dmY">d d m m y y y y</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className='row mb-3'>
                                                <div className='col-9'>
                                                    <p className='mb-0'>{t('setting.distanceBetweenCharacters')}</p>
                                                </div>
                                                <div className='col-3'>
                                                    <input type='text' name="chequeDateDistanceBetweenCharacters" value={form_inputs.chequeDateDistanceBetweenCharacters} onChange={handleInputChange} className='form-control' placeholder='mm' />
                                                </div>
                                            </div>

                                            <p><b><u>{t('setting.partyPayeeName')}</u></b></p>
                                            <div className='row mb-3'>
                                                <div className='col-9'>
                                                    <p className='mb-0'>{t('setting.startingLocationFromTopEdge')}</p>
                                                </div>
                                                <div className='col-3'>
                                                    <input type='text' name="payeeNameStartingLocationFromTop" value={form_inputs.payeeNameStartingLocationFromTop} onChange={handleInputChange} className='form-control' placeholder='mm' />
                                                </div>
                                            </div>
                                            <div className='row mb-3'>
                                                <div className='col-9'>
                                                    <p className='mb-0'>{t('setting.startingLocationFromLeftEdge')}</p>
                                                </div>
                                                <div className='col-3'>
                                                    <input type='text' name="payeeNameStartingLocationFromLeft" value={form_inputs.payeeNameStartingLocationFromLeft} onChange={handleInputChange} className='form-control' placeholder='mm' />
                                                </div>
                                            </div>
                                            <div className='row mb-3'>
                                                <div className='col-9'>
                                                    <p className='mb-0'>{t('setting.widthArea')}</p>
                                                </div>
                                                <div className='col-3'>
                                                    <input type='text' name="payeeNameWidth" value={form_inputs.payeeNameWidth} onChange={handleInputChange} className='form-control' placeholder='mm' />
                                                </div>
                                            </div>
                                        </div>

                                        <div className='col-sm-6'>
                                            <p><b><u>{t('setting.amountInWords')}</u></b></p>
                                            <div className='row mb-3'>
                                                <div className='col-9'>
                                                    <p className='mb-0'>{t('setting.startingLocationOf1stLineFromTopEdge')}</p>
                                                </div>
                                                <div className='col-3'>
                                                    <input type='text' name="amountWordsStartingLocation1LineFromTop" value={form_inputs.amountWordsStartingLocation1LineFromTop} onChange={handleInputChange} className='form-control' placeholder='mm' />
                                                </div>
                                            </div>
                                            <div className='row mb-3'>
                                                <div className='col-9'>
                                                    <p className='mb-0'>{t('setting.startingLocationOf1stLineFromLeftEdge')}</p>
                                                </div>
                                                <div className='col-3'>
                                                    <input type='text' name="amountWordsStartingLocation1LineFromLeft" value={form_inputs.amountWordsStartingLocation1LineFromLeft} onChange={handleInputChange} className='form-control' placeholder='mm' />
                                                </div>
                                            </div>
                                            <div className='row mb-3'>
                                                <div className='col-9'>
                                                    <p className='mb-0'>{t('setting.startingLocationOf2stLineFromTopEdge')}</p>
                                                </div>
                                                <div className='col-3'>
                                                    <input type='text' name="amountWordsStartingLocation2LineFromTop" value={form_inputs.amountWordsStartingLocation2LineFromTop} onChange={handleInputChange} className='form-control' placeholder='mm' />
                                                </div>
                                            </div>
                                            <div className='row mb-3'>
                                                <div className='col-9'>
                                                    <p className='mb-0'>{t('setting.startingLocationOf2stLineFromLeftEdge')}</p>
                                                </div>
                                                <div className='col-3'>
                                                    <input type='text' name="amountWordsStartingLocation2LineFromLeft" value={form_inputs.amountWordsStartingLocation2LineFromLeft} onChange={handleInputChange} className='form-control' placeholder='mm' />
                                                </div>
                                            </div>
                                            <div className='row mb-3'>
                                                <div className='col-9'>
                                                    <p className='mb-0'>{t('setting.widthArea')}</p>
                                                </div>
                                                <div className='col-3'>
                                                    <input type='text' name="amountWordsWidth" value={form_inputs.amountWordsWidth} onChange={handleInputChange} className='form-control' placeholder='mm' />
                                                </div>
                                            </div>

                                            <p><u><b>{t('setting.amountInFigures')}</b></u></p>
                                            <div className='row mb-3'>
                                                <div className='col-9'>
                                                    <p className='mb-0'>{t('setting.startingLocationFromTopEdge')}</p>
                                                </div>
                                                <div className='col-3'>
                                                    <input type='text' name="amountFiguresStartingLocationFromLeft" value={form_inputs.amountFiguresStartingLocationFromLeft} onChange={handleInputChange} className='form-control' placeholder='mm' />
                                                </div>
                                            </div>
                                            <div className='row mb-3'>
                                                <div className='col-9'>
                                                    <p className='mb-0'>{t('setting.startingLocationFromLeftEdge')}</p>
                                                </div>
                                                <div className='col-3'>
                                                    <input type='text' name="amountFiguresStartingLocationFromTop" value={form_inputs.amountFiguresStartingLocationFromTop} onChange={handleInputChange} className='form-control' placeholder='mm' />
                                                </div>
                                            </div>
                                            <div className='row mb-3'>
                                                <div className='col-9'>
                                                    <p className='mb-0'>{t('setting.widthArea')}</p>
                                                </div>
                                                <div className='col-3'>
                                                    <input type='text' name="amountFiguresWidth" value={form_inputs.amountFiguresWidth} onChange={handleInputChange} className='form-control' placeholder='mm' />
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                    <div className='text-center mt-3'>
                                        <button disabled={ButtonDisabled} className="btn btn-primary pt-2 pb-2">
                                            {ButtonDisabled && <i className="fa fa-spinner me-2 fa-spin"></i>} {t('save')}
                                        </button>
                                        <button onClick={setDefaultSetting} disabled={ButtonDisabled} type='button' className="btn btn-info ms-3">
                                            {ButtonDisabled && <i className="fa fa-spinner me-2 fa-spin"></i>} {t('setting.setDefault')}
                                        </button>
                                    </div>
                                </>}
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ChequeSettingForm;